import axios from 'axios';
import authHeader from './auth-header';
axios.defaults.baseURL =  process.env.VUE_APP_API_BASE
axios.defaults.timeout = 100000
class UserService {
    getBranchOrders($params) {
        return axios.get('/branch/order', { headers: authHeader(), params: $params });
    }
    BranchProductSearch($params) {
        return axios.get('/branch/product/search', {headers: authHeader(), params: $params})
    }
    BranchOrderSubmit($params) {
        return axios.post('/branch/order/submit', $params,{headers: authHeader()})
    }
    BranchOrderPreview($params) {
        return axios.post('/branch/order/preview', $params,{headers: authHeader()})
    }
    BranchGoldPrice() {
        return axios.get('/branch/gold/price', {headers: authHeader()})
    }
    BranchSilverPrice() {
        return axios.get('/branch/silver/price', {headers: authHeader()})
    }
    BranchCustomerSearch($params) {
        const {key, ...rest} = $params;
        return axios.get('/branch/user/list', {headers: authHeader(), params: {s: key, ...rest}})
    }
    BranchCustomerCreate($params) {
        return axios.post('/branch/user/create', $params,{headers: authHeader()})
    }
    getCustomer($params) {
        return axios.get(`/branch/user/${$params.user_id}`, {headers: authHeader()})
    }
}
export default new UserService();
